import { render, staticRenderFns } from "./SingleConcerti.vue?vue&type=template&id=0d82392f&"
import script from "./SingleConcerti.vue?vue&type=script&lang=js&"
export * from "./SingleConcerti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports